import { Injectable, inject } from '@angular/core';
import { ContractRole } from '@models/module/main';
import { CipoSignature } from '@module-definition/signature/common';
import { HttpService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class MainService {
  private http = inject(HttpService);

  createSignature(signature: Omit<CipoSignature, 'id'>) {
    return this.http.post<void>('_api/Main/CreateSignature', signature, { useLoader: false });
  }

  getContractRoles(contractId: number) {
    const params = this.http.buildHttpParams({ contractId });
    return this.http.get<ContractRole[]>('_api/Main/UserRolesForContract', {
      httpOptions: { params },
      useLoader: false,
    });
  }
}
